import React from 'react';
import { FiWifiOff } from 'react-icons/fi';

import Alert from '@fmbt/ui/Alert';
import StackedIconTitle from '@fmbt/ui/StackedIconTitle';

interface Props {
  errorMessage?: string;
}

function AlertWithOfflineResult({ errorMessage }: Props): JSX.Element | null {
  if (errorMessage === 'Network Error') {
    return (
      <div style={{ margin: '48px 24px' }}>
        <StackedIconTitle
          Icon={FiWifiOff}
          title="You seem to be offline"
          subTitle="Sorry, we can't load this data while you're not connected to the internet. Please reconnect and try again."
        />
      </div>
    );
  }

  if (errorMessage) {
    return <Alert message={errorMessage} />;
  }

  return null;
}

export default AlertWithOfflineResult;
